<template>
  <div class="bought-app">
    <b-row>
      <b-col md="12">
        <!-- <b-card header-tag="header" footer-tag="footer"> -->
        <!-- <div slot="header">
            <strong>Application settings</strong>
        </div>-->
        <b-list-group>
          <!-- Disclaimer -->
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Disclaimer</h5>
            </div>
            <p class="mb-1">
              In order for the app to generate the list of cross-sells products the application needs to analyse your order history and the list of the currently available products.
              The application generates a javascript asset file once the orders and products data is extracted. You may register that file manually or automatically in your shop's current theme using this page.
              The javascript file contains the cross-sells information of your whole store which means it may grow big if you have a lot of products and
              <i>
                <b>may slow down</b>
              </i> product page load (at least the first time you open a product page, then the script is cached by client browsers).
            </p>
            <p class="mb-1">
              Current free version of the application reindexes your orders and products
              <i>
                <b>once a week</b>
              </i>
              and then generates the new recommender script which may be registered instead of the older script automatically or manually.
              That means it has a delay for cross-sells information to populate to your store.
            </p>
            <p
              class="mb-1"
            >On other hand all calculations are done in the browser and no requests are being issued to third party servers which is the main reason for this app to stay free of charge.</p>
          </b-list-group-item>

          <!-- Snapshots -->
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Latest data snapshots</h5>
            </div>
            <p class="mb-1">
              Below you may see when the latest data snapshots were completed.
              Orders completed after the snapshot date and products that were added after the snapshot date are not showing up on Frequently Bought Together section.
            </p>
            <br>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                Product catalog snapshot:
                <i v-if="latestProductExtract != null">
                  created
                  <strong>{{ latestProductExtractText }}</strong>
                </i>
                <i v-else>{{ latestProductExtractText }}</i>
              </li>
              <li class="list-group-item">
                Orders snapshot:
                <i v-if="latestOrdersExtract != null">
                  created
                  <strong>{{ latestOrdersExtractText }}</strong>
                </i>
                <i v-else>{{ latestOrdersExtractText }}</i>
              </li>
            </ul>
          </b-list-group-item>

          <!-- Preferences -->
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Preferences</h5>
            </div>
            <p
              class="mb-1"
            >You may edit the default template of the product page "Frequently bought together" section yourself by clicking Edit button.</p>
            <br>
            <b-col v-if="settings != null">
              <b-row>
                <span class="form-row align-items-center preferences">
                  <c-switch
                    class="mx-1"
                    color="primary"
                    v-model="settings.enabled"
                    label
                    variant="pill"
                    v-on:change="saveSettings(settings)"
                  />
                  <span>Enable application.</span>
                </span>
              </b-row>
              <b-row>
                <span class="form-row align-items-center preferences">
                  <c-switch
                    class="mx-1"
                    color="primary"
                    v-model="settings.autoRenew"
                    label
                    variant="pill"
                    v-on:change="saveSettings(settings)"
                  />
                  <span>Automatically update asset script when reindexing store data. Your app section will always be up to date.</span>
                </span>
              </b-row>
              <div>
                <b-button
                  variant="primary"
                  :disabled="!enabled || autoRenew"
                >Generate javascript asset file and add to your store</b-button>
              </div>
            </b-col>
            <b-col v-else>
              <b-row>
                <p class="mb-1">Loading your settings....</p>
              </b-row>
            </b-col>
          </b-list-group-item>
          <!-- Edit template -->
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Cutomize "Frequently Bought Together" section HTML template</h5>
            </div>
            <p
              class="mb-1"
            >If you feel comfortable with HTML then you may edit the default template of the product's "Frequently Bought Together" section yourself by clicking Edit button.</p>
            <div class="col-auto">
              <button type="submit" class="btn btn-primary" @click="getTemplate">Edit app template</button>
              <!-- Modal Component -->
              <b-modal
                title="Application's HTML template"
                class="editor-dialog"
                v-model="showEditor"
                hide-footer
                centered
              >
                <editor
                  v-model="editorContent"
                  @init="editorInit"
                  lang="html"
                  theme="chrome"
                  width="550"
                  height="500"
                  class="editor"
                ></editor>

                <br>
                <!-- buttons -->
                <div>
                  <b-button-toolbar right class="pull-right">
                    <b-button-group class="mx-1" right>
                      <b-button
                        variant="primary"
                        :disabled="editorContent == initialContent"
                        @click="saveTemplate"
                      >Save and update your app</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1" right>
                      <b-button variant="secondary" @click="()=>{showEditor = false;}">Cancel</b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </b-modal>
            </div>
          </b-list-group-item>

          <!-- Help -->
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Help and Support</h5>
            </div>
            <p class="mb-1">
              You may contact app's support by sending email to
              <a
                href="mailto:support@altamenter.cloud"
                target="_top"
              >support@altamenter.cloud</a>
            </p>
          </b-list-group-item>
        </b-list-group>
        <!-- </b-card> -->
      </b-col>
    </b-row>

    <!-- MODALS -->
    <b-modal
      :title="successTitle"
      class="modal-success"
      v-model="successModal"
      ok-only
      ok-variant="success"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <span v-html="successMessage"></span>
    </b-modal>
    <b-modal
      title="Error happened"
      class="modal-danger"
      v-model="errorModal"
      ok-only
      ok-variant="danger"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >{{errorMessage}}</b-modal>
    <!-- /MODALS -->
  </div>
</template>
<script>
import extractgrid from "./ExtractGrid"
import recommendergrid from "./RecommenderGrid"
import { format, render, cancel, register } from 'timeago.js';
import { Switch as cSwitch } from '@coreui/vue'
import Vue from "vue";
import { debug } from 'util';

export default {
  props: {
    storeId: String,
    title: String
  },
  data: function () {
    return {
      // modals
      successModal: false,
      errorModal: false,
      errorMessage: "",
      successTitle: "",
      successMessage: "",

      // selected extracts
      productExtract: null,
      productExtractText: "",
      ordersExtract: null,
      ordersExtractText: "",

      // editor content
      editorContent: "Loading....",
      initialContent: "",
      showEditor: false,

      // latest extracts
      latestProductExtract: null,
      latestProductExtractText: "Getting information....",
      latestOrdersExtract: null,
      latestOrdersExtractText: "Getting information....",


      //settings
      settings: null,
      autoRenew: false,
      enabled: false
    };
  },
  components: {
    extractgrid,
    recommendergrid,
    editor: require('vue2-ace-editor'),
    cSwitch
  },
  mounted: async function () {
    var latestPE = await this.getLatestSnapshot("Products");
    if (latestPE !== null) {
      this.$data.latestProductExtractText = format(latestPE.completed);
      this.$data.latestProductExtract = latestPE;
    } else {
      latestProductExtractText = "Product catalog snapshot for your store has not yet been created"
    }

    var latestOE = await this.getLatestSnapshot("Orders");
    if (latestOE !== null) {
      this.$data.latestOrdersExtractText = format(latestOE.completed);
      this.$data.latestOrdersExtract = latestOE;
    } else {
      latestOrdersExtractText = "Orders snapshot for your store has not yet been created"
    }
    this.bindSettings();
  },
  methods: {
    format: function (date) {
      return format(date);
    },

    editorInit: function () {
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/html')
      require('brace/mode/javascript')    //language
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/snippets/javascript') //snippet
    },

    prodExtractSelected: function (e) {
      this.$data.productExtract = e;
      this.$data.productExtractText = `Snapshot of products created ${format(e.completed)}`
    },

    orderExtractSelected: function (e) {
      this.$data.ordersExtract = e;
      this.$data.ordersExtractText = `Snapshot of orders created ${format(e.completed)}`
    },

    getTemplate: async function () {
      try {
        //api/shopify/template/BOUGHT_TOGETHER/6452805721
        let response = await Vue.axios.get(new URL(process.env.VUE_APP_API_URL + `shopify/template/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${this.storeId}`), {});
        this.$data.editorContent = response.data.content;
        this.$data.initialContent = this.$data.editorContent;
        this.$data.showEditor = true;
      } catch (error) {
        this.$data.errorMessage = error.response ? error.response.data : "Error happened while getting your current template";
        this.$data.errorModal = true;
      }
    },

    getLatestSnapshot: async function (extractType) {
      try {
        let response = await Vue.axios.get(process.env.VUE_APP_API_URL + `shopify/list-extracts/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${extractType}/${this.storeId}?take=1&skip=0&orderby=completed&desc=true`);
        return response.data.items[0];
      }
      catch (error) {
        console.log(error.statusText);
        return null;
      }
    },

    getSettings: async function (extractType) {
      try {
        let response = await Vue.axios.get(process.env.VUE_APP_API_URL + `shopify/app-settings/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${this.storeId}`);
        return response.data;
      }
      catch (error) {
        console.log(error.statusText);
        return null;
      }
    },
    bindSettings: async function () {
      var settings = await this.getSettings();
      if (settings != null) {
        this.$data.settings = {};
        this.$data.settings.enabled = settings.hasOwnProperty('enabled') ? settings.enabled === "true" : true;
        this.$data.settings.autoRenew = settings.hasOwnProperty('autoRenew') ? settings.autoRenew === "true" : true;
        this.$data.autoRenew = this.$data.settings.autoRenew;
      }
    },

    saveSettings: async function (settings) {
      try {
        this.$data.autoRenew = Boolean(this.$data.settings.autoRenew);
        this.$data.enabled = Boolean(this.$data.settings.enabled);

        let response = await Vue.axios.post(process.env.VUE_APP_API_URL + `shopify/app-settings/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${this.storeId}`, {
          settings: settings
        });
      }
      catch (error) {
        console.log(error.statusText);
      }
    },

    saveTemplate: async function () {
      try {
        //api/shopify/template/BOUGHT_TOGETHER/6452805721
        let response = await Vue.axios.post(new URL(process.env.VUE_APP_API_URL + `shopify/template/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${this.storeId}`), {
          content: this.$data.editorContent
        });
        this.$data.showEditor = false;

      } catch (error) {
        this.$data.errorMessage = error.response ? error.response.data : "Error happened while saving your current template";
        this.$data.errorModal = true;
      }
    },

    generateJsRecommender: async function () {
      try {
        let response = await Vue.axios.post(new URL(process.env.VUE_APP_API_URL + `shopify/bought-together-js-recommender/generate`), {
          productExtractId: this.$data.productExtract.id,
          ordersExtractId: this.$data.ordersExtract.id,
          storeId: this.storeId,
          applicationName: process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME
        });
        this.$data.successTitle = "Your javascript asset is being generated.";
        this.$data.successMessage = "<h4>Success!</h4><p>After the asset is generated it will appear in the grid below and you will be able to add it to your store's theme.</p><p>Please note that generating the file might take some time. If you dont see it within an hour in your list of JS assets you may contact support.</p>";
        this.$data.successModal = true;
      } catch (error) {
        this.$data.errorMessage = error.response ? error.response.data : "Error happened while generating the asset. Please contact support.";
        this.$data.errorModal = true;
      }
    }
  }

}
</script>
<style lang="scss">
.app-container {
  background-color: #fdfdfd;
}

.editor {
  margin: 0 auto;
}
h5 {
  font-size: 1.2rem !important;
}
.mb-1,
.my-1 {
  margin: 0.75rem !important;
}
.editor-dialog {
  .modal-dialog {
    .modal-content {
      width: 600px !important;
    }
  }
}

.bought-app {
  .list-group-item {
    &:hover {
      z-index: initial !important;
    }
    p {
      text-align: justify;
    }
  }

  .preferences {
    padding-left: 12px;
    padding-bottom: 20px;
  }
}
</style>

